module.exports = "https://coursera_assets.s3.amazonaws.com/images/3b8bc425831a5a4c781e221fd871e798.png";